
var Model = require("../types/Model.js");

module.exports = new Model({
	name: "atouchawaysettings",
	init: init,
	triggers: triggers,
	listeners: listeners,

	refresh: refresh,
	handle_update: handle_update
});

function init() {
	this.refresh();
	this.push({});
}

function triggers() {
	return {
		update: update
	};
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/atouchaway/updated": handle_update,
	};
}

function refresh() {
	this.api.atouchaway.data().then(handle_refreshed.bind(this));
}

function handle_refreshed(data) {
	this.push(data);
}

function handle_update(data) {
	var oldData = this.data;
	this.extend(data);
	if(!data.careplan && oldData.careplan)
		this.dispatch("hidecareplan");
	if(!data.forms && oldData.forms)
		this.dispatch("hideforms");
	if(!data.myhealth && oldData.myhealth)
		this.dispatch("hidemyhealth");
	if(!data.workflow && oldData.workflow)
		this.dispatch("hideworkflow");
	if(!data.resources && oldData.resources)
		this.dispatch("hideresources");
	if(!data.status && oldData.status)
		this.dispatch("hidestatus");
}

function update(data) {
	this.api.atouchaway
		.update(data)
		.catch(console.error.bind(console))
		.then(handle_updated.bind(this));

	this.emit("save:trigger:start");

	this.emit("usermetrics:trigger:track", "update atouchaway settings");
}

function handle_updated() {
	this.emit("save:trigger:finish");
}